import React, { useState, useEffect } from "react";
import { useWatchState } from "@/store";
import { BaseService } from "@/service";
import { Modal, Button, Input, message, Dropdown, Menu } from "antd";
import "./style.less";

const App = (props) => {
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(undefined);
  const [name, setName] = useState(undefined);
  const [[{ IS_LOGIN, info }], [i18n]] = useWatchState(["user", "i18n"]);
  const [[{ title, show, hide, width = 300, callback }]] = useWatchState([
    "modal.bindOrg",
  ]);

  const onChangeName = (e) => setName(e.target.value);

  const searchOrg = (name) => {
    // BaseService.list({
    //     table: "thtt_organization",
    //     columns: "organization_id,name",
    //     where: {
    //         name: {
    //             condition: "LIKE",
    //             value: name
    //         },
    //         is_delete: 0
    //     }
    // }).then(res => {
    //     const data = res.data.result;
    //     setOrgs(data);
    // })
  };

  useEffect(() => {
    searchOrg(name);
  }, [name]);

  const onBind = async () => {
    if (!IS_LOGIN) return message.warn(i18n.pleaseLogin);
    if (!name) return message.warn("请输入单位名称！");

    if (!id) {
      const res = await BaseService.list({
        table: "thtt_organization",
        columns: "organization_id,name",
        where: {
          name: {
            condition: "LIKE",
            value: name,
          },
          is_delete: 0,
        },
      });
      const data = res.data.result;

      // 如果没有此机构
      if (!data.length) {
        BaseService.add({
          table: "thtt_organization",
          data: {
            name,
            type: 4,
            audit_status: 4,
          },
        });
      }
      // const id =
    }

    // 先查询是否已经绑定过了

    callback({ name, organization_id: id });
    hide();
  };
  const onSelectOrgHandler = ({ organization_id, name }) => {
    setId(organization_id);
    setName(name);
  };

  const menu = (orgs) => (
    <Menu>
      {orgs.map(({ organization_id, name }) => (
        <Menu.Item
          onClick={onSelectOrgHandler.later({ organization_id, name })}
        >
          {name}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Modal
      className="modal-login"
      title={title}
      visible={show}
      width={width}
      maskClosable={false}
      onCancel={hide}
      footer={false}
    >
      <div className="modal-login__body">
        <Dropdown overlay={menu}>
          <Input
            value={name}
            placeholder="请输入单位名称"
            onChange={onChangeName}
          />
        </Dropdown>
        <Button onClick={onBind} loading={loading}>
          确认
        </Button>
      </div>
    </Modal>
  );
};

export default App;
